import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Store } from '@ngrx/store';
import { UserService } from 'src/app/services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Form, FormControl, Validators } from '@angular/forms';
import { PerfilComponent } from '../perfil/perfil.component';
import * as moment from 'moment';
import { forEach } from '@angular/router/src/utils/collection';
import { isNull } from 'util';
import { isEmpty } from 'rxjs/operators';
import { fadeOutCollapseOnLeaveAnimation } from 'angular-animations';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { Router } from '@angular/router';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';



declare const swal: any;

interface AppState {
  form: Form;
}

@Component({
  selector: 'app-seguimiento-expediente',
  templateUrl: './seguimiento-expediente.component.html',
  styleUrls: ['./seguimiento-expediente.component.css'],
  providers: [ClaveUnicaService]
})
export class SeguimientoExpedienteComponent implements OnInit {

  public expediente_info
  public link_acta
  public arreglo
  buscando = false
  public numSol = new FormControl('', [Validators.required]);
  public rut = new FormControl('', [Validators.required]);
  public fecha_ingreso = new FormControl('', [Validators.required]);
  public expa1 = true
  public expa2 = true
  public expa3 = true
  public expa4 = true
  public colorExpa1 = "#01BAC9"
  public colorExpa2 = "#01BAC9"
  public colorExpa3 = "#01BAC9"
  public colorExpa4 = "#01BAC9"
  public calculoD = false


  public link_acta2 = "acta-expediente?id="

  //@ViewChild('htmlpdf') content: ElementRef;

  identity
  token

  constructor(
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private store: Store<AppState>,
    private _user: UserService,
    private spinner: NgxSpinnerService,
    private _cd: ChangeDetectorRef,
    private _router: Router,
    private claveUnicaService: ClaveUnicaService
  ) {
    console.log("SeguimientoExpedienteComponent")

    this.identity = this._user.getIdentity();

    if (sessionStorage.getItem('identity-domCloud')) {
      let identityData = this._user.getIdentity();
      this.rut.setValue(identityData.rut + '-' + identityData.dv);
      this.searchUser()
    }/*  else {
      this._router.navigate(['/inicio'])
      swal({
        type: 'warning',
        text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      })
    } */
  }

  ngOnInit() {

  }

  get_expediente() {
    this.spinner.show()
    var rut_new = this.rut.value
    rut_new = rut_new.slice(0, -2)
    this._user.get_expediente(this.numSol.value, rut_new).subscribe(response => {




      console.log("response: ", response)
      var fechax, fechay, peso1, peso2
      if (response.expediente.length > 0) {

        this.spinner.hide()

        this.expediente_info = response.expediente
        this.buscando = true
        console.log(this.expediente_info)

        this.calculoD = this.expediente_info[0].fieldData['Tex_CD_Fecha_Firma_DOM'] ? true : false
        console.log("Tiene calculo", this.calculoD);

        fechax = this.expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Fecha_Creacion']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") { fechay = "" }
        this.expediente_info[0].fieldData['Tramite_Solicitudes::TRA_Fecha_Creacion'] = fechay

        fechax = this.expediente_info[0].fieldData['TCo_Acta_Fecha_1_Max_Emitir']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['TCo_Acta_Fecha_1_Max_Emitir'] = fechay

        fechax = this.expediente_info[0].fieldData['Tex_Acta_Fecha_Emision']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['Tex_Acta_Fecha_Emision'] = fechay

        fechax = this.expediente_info[0].fieldData['Tex_Acta_Fecha_Notificacion']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['Tex_Acta_Fecha_Notificacion'] = fechay

        fechax = this.expediente_info[0].fieldData['Tex_Acta_Fecha_Reingreso']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['Tex_Acta_Fecha_Reingreso'] = fechay

        fechax = this.expediente_info[0].fieldData['Tex_CD_Fecha_Giro']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['Tex_CD_Fecha_Giro'] = fechay

        fechax = this.expediente_info[0].fieldData['Tex_CD_Fecha_Notificacion']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['Tex_CD_Fecha_Notificacion'] = fechay

        fechax = this.expediente_info[0].fieldData['Tex_Fecha_Aprobacion']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['Tex_Fecha_Aprobacion'] = fechay



        const formatterPeso = new Intl.NumberFormat('es-CL', {
          style: 'currency',
          currency: 'CLP',
          minimumFractionDigits: 0
        })




        peso1 = this.expediente_info[0].fieldData.Tex_CD_TOTAL_PAGAR_Estampillas



        peso2 = formatterPeso.format(peso1)
        if (peso2 != "$NaN") {
          this.expediente_info[0].fieldData.Tex_CD_TOTAL_PAGAR_Estampillas = peso2
        } else {
          this.expediente_info[0].fieldData.Tex_CD_TOTAL_PAGAR_Estampillas = "$0"
        }

        if (this.expediente_info[0].fieldData['Administracion 3::Adm_Nombre_Completo'] == "" && this.expediente_info[0].fieldData['Administracion 3::Adm_Fono'] == "" && this.expediente_info[0].fieldData['Administracion 3::Adm_Mail'] == "" && this.expediente_info[0].fieldData['TCo_Acta_Fecha_1_Max_Emitir'] == "") {
          this.colorExpa1 = "titleExpaB"
        } else {
          this.colorExpa1 = "titleExpaA"
        }

        if (this.expediente_info[0].fieldData['Tex_Acta_Fecha_Emision'] == "" && this.expediente_info[0].fieldData['Tex_Acta_Fecha_Notificacion'] == "" && this.expediente_info[0].fieldData['Tex_Acta_Fecha_Reingreso'] == "") {
          this.colorExpa2 = "titleExpaB"
        } else {
          this.colorExpa2 = "titleExpaA"
        }

        if (this.expediente_info[0].fieldData['Tex_CD_Fecha_Giro'] == "" && this.expediente_info[0].fieldData['Tex_CD_TOTAL_PAGAR_Estampillas'] == "$0" && this.expediente_info[0].fieldData['Tex_CD_Fecha_Notificacion'] == "") {
          this.colorExpa3 = "titleExpaB"
        } else {
          this.colorExpa3 = "titleExpaA"
        }


        if (this.expediente_info[0].fieldData['Tex_Apr_Numero'] == "" && this.expediente_info[0].fieldData['Tex_Fecha_Aprobacion'] == "") {
          this.colorExpa4 = "titleExpaB"
        } else {
          this.colorExpa4 = "titleExpaA"
        }



      } else {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "No se encontraron registros de certificados con ese numero de solicitud",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }

    }, error => {
      console.log(error)
    })
    this.spinner.hide()
  }


  volver() {
    this.buscando = false
    this.numSol.setValue("")
    this.fecha_ingreso.setValue("")

  }

  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");

    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
    this.back()
  }
  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  back() {
    this._router.navigate(['/inicio'])
  }



  searchUser() {
    /* Buscar si existe en fm */
    let identityData = this._user.getIdentity();
    let rut = identityData.rut + identityData.dv
    this._user.buscarUsuario(rutClean(rut)).subscribe(
      response => {
        if (response.message) {
          this.spinner.hide();

        }
        if (response.register) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

        if (response.update) {
          this.spinner.hide();
          console.log(response);

          this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw', // Ajusta el ancho
            height: 'auto', // Ajusta la altura
            disableClose: true // Evita cerrar al hacer clic fuera (opcional)
          });
        }

      },
      error => {
        let e = JSON.parse(error._body);
        this.spinner.hide();
      }
    )
  }

}
